/**
 * Config: Navigation
 * -----------------------------------------------------------------------------
 * Define special meta values for navigation.
 *
 */
export const specialLinks = {
  banner: '[banner]',
  col: '[col-',
  color: '[color]',
  heading: '[heading]',
  showCta: '[show-cta]',
}
